import { Component, OnInit, input, inject } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ApContentService, ApContentPipe, ApKeyOverridePipe, ApContentComponent } from '@ap/content';
import { ErrorMessages } from '@ap/form/errors';
import { ApRadioGroupComponent, ApRadioButtonComponent } from '@ap/radio';
import { ApInputComponent } from '@ap/input';
import { ApDiacriticsNormalizeFormValueDirective } from '@ap/diacritics-normalize';
import { ApNotificationComponent } from '@ap/notification';
import { ApFormControlPipe } from '@ap/cdk';
import { ApInitialsInputComponent } from '@ap/input/initials';

import personalDetailsLimitedContent from './personal-details-limited.content.json';
import { PersonalDetailsLimitedForm } from './personal-details-limited.model';
/** This component can be used by customers to enter limited details about a person */
@Component({
    selector: 'ap-personal-details-limited',
    templateUrl: './personal-details-limited.component.html',
    styleUrls: ['../personal-details.component.scss'],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        ApRadioGroupComponent,
        ApRadioButtonComponent,
        ApInitialsInputComponent,
        ApInputComponent,
        ApDiacriticsNormalizeFormValueDirective,
        ApNotificationComponent,
        ApContentComponent,
        ApFormControlPipe,
        ApContentPipe,
        ApKeyOverridePipe
    ]
})
export class ApPersonalDetailsLimitedComponent implements OnInit {
    private readonly contentService = inject(ApContentService);

    /**
     * Required - The form group to bind to see {@link PersonalDetailsLimitedService}
     */
    public readonly control = input.required<FormGroup<PersonalDetailsLimitedForm>>();

    /**
     * Keymap for content overrides
     */
    public readonly contentKeyMap = input<{
        [contentKey: string]: string;
    }>();

    protected lastNameHasDiacritics = false;
    protected genderOptions = [
        { value: 'M', content: 'personal.details.limited.gender.M' },
        { value: 'F', content: 'personal.details.limited.gender.F', last: true }
    ];
    protected genderErrorMessages: ErrorMessages;
    protected initialsErrorMessages: ErrorMessages;
    protected insertionErrorMessages: ErrorMessages;
    protected lastNameErrorMessages: ErrorMessages;

    public ngOnInit(): void {
        this.contentService.addContentItems(personalDetailsLimitedContent);
        this.setErrorMessages();
    }

    protected diacriticsChange(diacriticValue: boolean): void {
        this.lastNameHasDiacritics = diacriticValue;
    }

    protected getLastName(): string {
        return this.control().get('lastName').value;
    }

    private setErrorMessages(): void {
        this.genderErrorMessages = {
            required: this.contentService.get('personal.details.limited.gender.error.required')
        };
        this.initialsErrorMessages = {
            required: this.contentService.get('personal.details.limited.initials.error.required'),
            incorrect: this.contentService.get('personal.details.limited.initials.error.incorrect')
        };
        this.insertionErrorMessages = {
            incorrect: this.contentService.get('personal.details.limited.insertion.error.incorrect')
        };
        this.lastNameErrorMessages = {
            required: this.contentService.get('personal.details.limited.lastName.error.required'),
            incorrect: this.contentService.get('personal.details.limited.lastName.error.incorrect')
        };
    }
}
